export const SortOptionEnum = {
  ItemCode: 0,
  ItemDescription: 1,
  Vendor: 2,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ItemListingReportEnum.js